import { statusStyle } from "../lib/utils-format";

export default function StatusBadge({ status, className = "", testId }) {
    return (
        <span
            data-testid={testId}
            className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${statusStyle(status)} ${className}`}
        >
            {String(status || "—").replace(/_/g, " ")}
        </span>
    );
}
